export default __webpack_public_path__ + "static/media/Gellix-SemiBold.c5cec639.woff2";